import { usePathname } from 'next/navigation'

export const useShowAppNudge = (blockedPaths: string[]): boolean => {
  const pathname = usePathname()
  if (!pathname) return true // show by default

  return !blockedPaths.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  )
}
